import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { Card } from "@pages/AdminDashboard/ui/Card";
import { PageHeader } from "@pages/AdminDashboard/ui/PageHeader";

const [, , , spaceLg] = adminTokens.spacing;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceLg}px;
`;

interface ComingSoonProps {
  name: string;
}

// A screen that is not built yet: it names itself and says so (SHELL-R11).
export const ComingSoon = ({ name }: ComingSoonProps) => (
  <Stack>
    <PageHeader title={name} />
    <Card>{`${name} is coming soon.`}</Card>
  </Stack>
);
